/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { isNone } from '@ember/utils';
import clamp from 'clamp';

@tagName('')
export default class Phone extends Component {
  // external API
  isRefreshing = false;

  message = null;
  currentDevicePreview = null;
  messageBody = null;
  messageBodyElement = null;

  @action
  didInsertMessageBody(messageBodyElement) {
    this.messageBody = this.get('message.body') || '…';

    this.messageBodyElement = messageBodyElement;

    this.insertMessageBody();
  }

  didRender() {
    super.didRender(...arguments);
    this.messageBody = this.get('message.body') || '…';

    this.insertMessageBody();
  }

  insertMessageBody() {
    if (this.messageBodyElement == null) {
      return;
    }

    this.messageBodyElement.textContent = this.messageBody;

    let currentDevicePreview = this.get('currentDevicePreview');
    if (!isNone(currentDevicePreview) && currentDevicePreview.maxLines > 0) {
      clamp(this.messageBodyElement, { clamp: currentDevicePreview.maxLines, useNativeClamp: false });
    }
  }
}
